module.exports = __webpack_public_path__ + "img/P34-zh.7bcd1cbc.png";